import NotificationSound from "../assets/sounds/notification.mp3";

const notification = new Audio(NotificationSound);

export const playNotificationSoundEffect = () => {
  notification.play();
};